/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_No_Media_ErrorInputs */



/**
* | output |
* | --- |
* | "No media file loaded" |
*
* @param {Ocr_No_Media_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_no_media_error = /** @type {((inputs?: Ocr_No_Media_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_No_Media_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun fichier multimédia chargé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Mediendatei geladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun file multimediale caricato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиафайл не загружен")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha cargado ningún archivo multimedia.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未加载媒体文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルが読み込まれませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई मीडिया फ़ाइल लोड नहीं हुई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum arquivo de mídia carregado")
	return /** @type {LocalizedString} */ ("No media file loaded")
});